import React, { useEffect } from 'react';

import Breadcrumbs from '@/components/common/Breadcrumbs';
import MaxWidth from '@/components/common/layout/MaxWidth';
import SectionTitle from '@/components/common/ui/SectionTitle';
import FeaturedParks from '@/components/park-guide-directory/FeaturedParks';
import Hero from '@/components/park-guide-directory/Hero';
import ParkList from '@/components/park-guide-directory/ParkList';
import TopNavigation from '@/components/park-guide-directory/TopNavigation';
import Link from '@/components/switchback/Link/Link';
import { CMSPageData, CMSPageMetadata, CMSPageType, ParkType } from '@/services/getCMSPageData';
import { trackEvent } from '@/services/track-event';

import css from './ParkGuideDirectoryTemplate.module.css';

interface ParkGuideDirectoryPageMetadata extends CMSPageMetadata {
  page_type: CMSPageType.ParkGuideDirectory;
  sections: {
    park_type: ParkType;
    view_all_url: string;
  }[];
}

export interface ParkGuideDirectoryPageData extends CMSPageData {
  metadata: ParkGuideDirectoryPageMetadata;
}

const nameMaps = {
  national: 'National',
  state: 'State',
  canada: 'Canadian',
  nat_forest: 'National Forest',
  coe: 'COE',
  blm: 'BLM',
};
const ParkGuideDirectoryTemplate: React.FC<
  React.PropsWithChildren<ParkGuideDirectoryPageData>
> = props => {
  const { title, breadcrumbs, sections } = props.metadata;

  useEffect(() => {
    trackEvent({
      event: 'Locality : Viewed page',
      pageType: 'Park guide directory',
    });
  }, []);

  return (
    <div className={css.parkDirectoryContainer}>
      <Hero title={title} />
      <TopNavigation />

      <div className="py-4">
        <Breadcrumbs breadcrumbs={breadcrumbs} />
      </div>

      {sections.map(section => {
        return (
          <MaxWidth id={section.park_type} className={`mb-8`} key={section.park_type}>
            <SectionTitle>
              Popular <span>{nameMaps[section.park_type]}</span> Parks
            </SectionTitle>
            <FeaturedParks section={section} />
            <h2 className="mb-4">
              More <span>{nameMaps[section.park_type]}</span> Parks
            </h2>
            <ParkList section={section} />
            <Link href={section.view_all_url} className={css.viewAll}>
              View All
            </Link>
          </MaxWidth>
        );
      })}
    </div>
  );
};

export default ParkGuideDirectoryTemplate;
